export interface IProfileDetails {
  avatar: string
  fName: string
  company: string
  contactPhone: string
  companySite: string
  country: string
  language: string
  timeZone: string
  currency: string
  communications: {
    email: boolean
    phone: boolean
  }
  allowMarketing: boolean
  membershipType: number
}

export interface cProfileDetails {
  avatar: string
  fName: string
  contactPhone: string
  language: string
  timeZone: string
}

export interface IUpdateEmail {
  newEmail: string
  confirmPassword: string
}

export interface IUpdatePassword {
  currentPassword: string
  newPassword: string
  passwordConfirmation: string
}

export interface IConnectedAccounts {
  google: boolean
  github: boolean
  stack: boolean
}

export interface IEmailPreferences {
  insights: boolean
  payouts: boolean
  newsletters: boolean
  blogs: boolean
  campaigns: boolean
  usageAlerts: boolean
}

export interface IInformationPreferences {
  insights: {
    email: boolean
    notification: boolean
  }
  newInvoices: {
    email: boolean
    notification: boolean
  }
  newsletters: {
    email: boolean
    notification: boolean
  }
  blogs: {
    email: boolean
    notification: boolean
  }
  campaigns: {
    email: boolean
    notification: boolean
  }
  usageAlerts: {
    email: boolean
    notification: boolean
  }
}

export interface IFreezeAccount {
  confirm: boolean
}

export const profileDetailsInitValues: IProfileDetails = {
  avatar: '/media/avatars/300-1.jpg',
  fName: 'Jerry Smith',
  company: 'AISenseUs',
  contactPhone: '044 1234 123 123',
  companySite: 'aisenseus.net',
  country: '',
  language: '',
  timeZone: '',
  currency: '',
  communications: {
    email: false,
    phone: false,
  },
  allowMarketing: false,
  membershipType: 0,
}

export const updateEmail: IUpdateEmail = {
  newEmail: 'support@keenthemes.com',
  confirmPassword: '',
}

export const updatePassword: IUpdatePassword = {
  currentPassword: '',
  newPassword: '',
  passwordConfirmation: '',
}

export const connectedAccounts: IConnectedAccounts = {
  google: true,
  github: true,
  stack: false,
}

export const emailPreferences: IEmailPreferences = {
  insights: true,
  payouts: true,
  newsletters: true,
  blogs: true,
  campaigns: true,
  usageAlerts: true,
}

export const informationPreferences: IInformationPreferences = {
  insights: {
    email: true,
    notification: true,
  },
  newInvoices: {
    email: true,
    notification: true,
  },
  newsletters: {
    email: true,
    notification: true,
  },
  blogs: {
    email: true,
    notification: true,
  },
  campaigns: {
    email: true,
    notification: true,
  },
  usageAlerts: {
    email: true,
    notification: true,
  },
}

export const freezeAccount: IFreezeAccount = {
  confirm: false,
}
